<template>
    <div class="modal">
        <div class="modal_content">
            <div class="modal_header">
                <div v-if="this.$store.getters.getConfigPc.messageModal" class="modal_title">
                    <span :class="{ 'active': activeType === 1 }" @click="activeTypeChoose(1)">{{
                        $t('msg_title')
                    }}</span>
                    <!-- <span :class="{'active':activeType === 2}" @click="activeTypeChoose(2)">{{ $t('leaveHis') }}</span> -->
                </div>
                <div v-else class="modal_title">{{ $t('eval_title') }}</div>
                <div class="close" @click="closeModal()"></div>
            </div>
            <div v-if="this.$store.getters.getConfigPc.messageModal && activeType === 1" class="modal_body scroll_bar">
                <p>{{ $t('msg_desc') }}</p>
                <div class="form_item">
                    <div>
                        <span class="red">*</span>
                        <span>{{ $t('userName') }}</span>
                    </div>
                    <el-input v-model="customerName" type="text" :placeholder="$t('input')" />
                </div>
                <div class="form_item">
                    <div>
                        <span>{{ $t('userPhone') }}</span>
                    </div>
                    <el-input v-model="customerPhone" type="text" :placeholder="$t('input')" />
                </div>
                <div class="form_item">
                    <div>
                        <span>{{ $t('userEmail') }}</span>
                    </div>
                    <el-input v-model="customerEmail" type="text" :placeholder="$t('input')" />
                </div>
                <div class="form_item">
                    <div>
                        <span class="red">*</span>
                        <span>备注说明</span>
                    </div>
                    <el-input type="textarea" v-model="msgContent" :placeholder="$t('pleInput')" />
                </div>
                <button :style="{ background: `linear-gradient(to right,  ${initData.mainColor})` }"
                    @click="sendMessage">{{ $t('submitLeave') }}
                </button>
            </div>
            <div v-if="this.$store.getters.getConfigPc.messageModal && activeType === 2" class="modal_body scroll_bar">
                <div class="leave_msg_item" v-for="item in list">
                    <div>
                        <span class="label">客户姓名：</span>
                        <span>{{ item.customerName }}</span>
                    </div>
                    <div>
                        <span class="label">客户邮箱：</span>
                        <span>{{ item.customerEmail }}</span>
                    </div>
                    <div>
                        <span class="label">客户电话：</span>
                        <span>{{ item.customerPhone }}</span>
                    </div>
                    <div>
                        <span class="label">留言内容：</span>
                        <span>{{ item.msgContent }}</span>
                    </div>
                    <div>
                        <span class="label">提交时间：</span>
                        <span>{{ formDate(item.createTime) }}</span>
                    </div>
                    <div>
                        <span class="label">留言状态：</span>
                        <span>{{ item.msgState == 1 ? '已处理' : '未处理' }}</span>
                    </div>
                    <div v-if="item.updateTime">
                        <span class="label">处理时间：</span>
                        <span>{{ item.updateTime }}</span>
                    </div>
                    <div v-if="item.updateUserName">
                        <span class="label">处理时间：</span>
                        <span>{{ formDate(item.updateUserName) }}</span>

                    </div>
                </div>
            </div>
            <div v-if="this.$store.getters.getConfigPc.evaluateModal" class="modal_body scroll_bar">
                <div v-if="connectStatus === 'robot'">
                    <p :style="{ color: '#00A1E2'  }">{{ $t('isResolved') }}</p>
                    <div class="row">
                        <div :class="type ? 'item good active' : 'item good'" class="item"
                            :style="{ backgroundColor: (type ? '#00A1E2'  : 'white') }" @click="chooseType(1)">
                            <span class="eval_icon "></span>
                            {{ $t('solved') }}
                        </div>
                        <div :class="type ? 'item bad' : 'item bad active'"
                            :style="{ backgroundColor: (!type ? '#00A1E2'  : 'white') }" @click="chooseType(0)">
                            <span class="eval_icon "></span>
                            {{ $t('noSolved') }}
                        </div>
                    </div>
                    <p class="eval_desc" v-if="!type" :style="{ color: '#00A1E2'  }">{{ $t('leaveTip') }}</p>
                    <div class="row" v-if="!type">
                        <div class="item"
                            :style="{ backgroundColor: (suggestion[0].value ? '#00A1E2'  : 'white'), color: (suggestion[0].value ? 'white' : '#00A1E2' ) }"
                            @click="chooseSuggestion(0)">
                            {{ suggestion[0].name }}
                        </div>
                        <div class="item"
                            :style="{ backgroundColor: (suggestion[1].value ? '#00A1E2'  : 'white'), color: (suggestion[1].value ? 'white' : '#00A1E2' ) }"
                            @click="chooseSuggestion(1)">
                            {{ suggestion[1].name }}
                        </div>
                    </div>
                    <div class="row" v-if="!type">
                        <div class="item"
                            :style="{ backgroundColor: (suggestion[2].value ? '#00A1E2'  : 'white'), color: (suggestion[2].value ? 'white' : '#00A1E2' ) }"
                            @click="chooseSuggestion(2)">
                            {{ suggestion[2].name }}
                        </div>
                        <div class="item"
                            :style="{ backgroundColor: (suggestion[3].value ? '#00A1E2'  : 'white'), color: (suggestion[3].value ? 'white' : '#00A1E2' ) }"
                            @click="chooseSuggestion(3)">
                            {{ suggestion[3].name }}
                        </div>
                    </div>
                    <div class="row" v-if="!type">
                        <el-input  type="textarea" :placeholder="$t('leaveInput')"
                            v-model="suggester"></el-input>
                    </div>
                    <div v-if="type" class="noData"></div>
                </div>
                <div v-if="connectStatus === 'manual'">
                    <div class="manual" v-if="evaluateData.starList">
                        <div class="row" v-if="evaluateData.evaluateAdminSolve">
                            <div :class="type ? 'item good active' : 'item good'"
                                :style="{ backgroundColor: (type ? '#00A1E2'  : 'white') }"
                                @click="chooseType(1)">
                                <span class="eval_icon "></span>
                                {{ $t('solved') }}
                            </div>
                            <div :class="type ? 'item bad' : 'item bad active'"
                                :style="{ backgroundColor: (!type ? '#00A1E2'  : 'white') }"
                                @click="chooseType(0)">
                                <span class="eval_icon "></span>
                                {{ $t('noSolved') }}
                            </div>
                        </div>
                        <div class="dm_evaluate" v-if="evaluateData.evaluateModel !== 2">
                            <!-- <span :class="star >= 1 ? 'star active':'star'" @click="chooseStar(1)"></span>
              <span :class="star >= 2 ? 'star active':'star'" @click="chooseStar(2)"></span>
              <span :class="star >= 3 ? 'star active':'star'" @click="chooseStar(3)"></span>
              <span :class="star >= 4 ? 'star active':'star'" @click="chooseStar(4)"></span>
              <span :class="star === 5 ? 'star active':'star'" @click="chooseStar(5)"></span> -->

                            <!-- <span  @click="chooseStar(1)">   
                 <img v-if="star==1" src="../../../static/image/npsFeel1.png" alt="" srcset="">
                <img v-if="star!=1" src="../../../static/image/npsFeelGrey1.png" alt="" srcset=""></span> -->
                <span  class="plf20" @click="chooseStar(2)">
                                <img width="60" v-if="star == 2" src="../../../static/image/frown.png" alt="" srcset="" />
                                <img width="60"  v-if="star != 2" src="../../../static/image/frown2.png" alt=""
                                    srcset="" /></span>
                            <!-- <span  @click="chooseStar(3)">   
                <img v-if="star==3" src="../../../static/image/npsFeel3.png" alt="" srcset="">
                <img v-if="star!=3" src="../../../static/image/npsFeelGrey3.png" alt="" srcset=""></span> -->
                            <span  class="plf20" @click="chooseStar(4)">
                                <img width="60" v-if="star == 4" src="../../../static/image/meh.png" alt="" srcset="" />
                                <img width="60"  v-if="star != 4" src="../../../static/image/meh2.png" alt="" srcset="" />
                            </span>
                            <span  class="plf20" @click="chooseStar(5)">
                                <img width="60"  v-if="star == 5" src="../../../static/image/smile.png" alt="" srcset="" />
                                <img width="60"  v-if="star != 5" src="../../../static/image/smile2.png" alt="" srcset="" />
                            </span>
                        </div>
                        <div>
                            <p :style="{ color: '#00A1E2'  }">{{
                                evaluateData.starList[star - 1].levelDescription
                            }}</p>
                        </div>
                        <div class="row">
                            <div v-for="(target, index) in evaluateData.starList[star - 1].select" v-if="target.name"
                                :key="target.name + Math.random() * 100"
                                :style="{ backgroundColor: (target.value ? '#00A1E2'  : 'white'), color: (target.value ? 'white' : '#00A1E2' ) }"
                                class="item" @click="chooseAdvice(target)">
                                {{ target.name }}
                            </div>
                        </div>

                        <div class="row">
                            <el-input  type="textarea"
                                :placeholder="evaluateData.starList[star - 1].evaluateGuideMsg"
                                v-model="suggester"></el-input>
                        </div>
                    </div>
                </div>

                <button :style="{ background: `#00A1E2` }"
                    @click="sendEvaluate">{{ $t('submitEva') }}
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import chatApi from "../methods";
import { Toast } from 'mint-ui';
import store from "../../store/index";

export default {
    name: "modal",
    data() {
        return {
            messageModal: false,
            evaluateModal: false,
            suggestion: [
                { name: this.$t('robotEva1'), value: 0 },
                { name: this.$t('robotEva2'), value: 0 },
                { name: this.$t('robotEva3'), value: 0 },
                { name: this.$t('robotEva4'), value: 0 }
            ],
            advice: [
                { name: this.$t('customerEva1'), value: 0 },
                { name: this.$t('customerEva2'), value: 0 },
                { name: this.$t('customerEva3'), value: 0 },
                { name: this.$t('customerEva4'), value: 0 }
            ],
            title: '',
            type: 1,
            suggester: '',
            star: 5,
            formData: {},
            msgContent: '',
            customerEmail: '',
            customerName: '',
            customerPhone: '',
            activeType: 1,
            list: [

            ]
        }
    },
    mounted() {
        this.messageModal = this.$store.getters.getConfigPc.messageModal;
        this.evaluateModal = this.$store.getters.getConfigPc.evaluateModal;
    },
    computed: {
        showFormChat() {
            return this.$store.state.showFormChat;
        },
        connectStatus() {
            return this.$store.state.connectStatus
        },
        evaluateData() {
            return this.$store.state.evaluateData
        },
        initData() {
            return this.$store.state.initData;
        },
    },

    methods: {
        formDate(value, fmt) {
            if (!value) {
                return '--'
            }
            fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                'M+': getDate.getMonth() + 1,
                'd+': getDate.getDate(),
                'h+': getDate.getHours(),
                'm+': getDate.getMinutes(),
                's+': getDate.getSeconds(),
                'q+': Math.floor((getDate.getMonth() + 3) / 3),
                'S': getDate.getMilliseconds()
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (let k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                }
            }
            return fmt;
        },

        activeTypeChoose(type) {
            this.activeType = type;
            if (type === 2) {
                this.getLeaveMsg();
            }
        },
        getLeaveMsg() {
            chatApi.getLeaveMsg((result) => {
                this.list = result.data;
            })
        },
        closeModal() {
            this.$store.dispatch('setConfigPc', [{ key: 'showModal', value: false }, {
                key: 'evaluateModal',
                value: false
            }, { key: 'messageModal', value: false }])
        },
        // 解决未解决
        chooseType(type) {
            this.type = type;
            this.suggestion.forEach(sug => {
                sug.value = 0
            })
            this.suggester = '';
        },
        // 选中建议
        chooseSuggestion(index) {
            this.suggestion[index].value = !this.suggestion[index].value;
        },
        // 人工建议
        chooseAdvice(obj) {
            obj.value = !obj.value;
            // this.evaluateData.starList[this.star - 1].select[index].value = !this.evaluateData.starList[this.star - 1].select[index].value;
        },
        // 发送留言
        sendMessage() {
            // let param = {
            //     "customerEmail": this.customerEmail,
            //     "customerName": this.customerName,
            //     "customerPhone": this.customerPhone,
            //     "msgContent": this.msgContent,
            // }
            // chatApi.submitMessage(param, () => {
            //     this.customerEmail = '';
            //     this.customerName = '';
            //     this.customerPhone = '';
            //     this.msgContent = '';
            //     store.dispatch('setConfigPc', [{key: 'showModal', value: false}, {
            //         key: 'messageModal',
            //         value: false
            //     }])
            // })

            if (this.customerName == "") {
                Toast({
                    message: "联系姓名不能为空",
                    duration: 1000,
                });
                return;
            }
            if (!this.checkPhone(this.customerPhone)) {
                Toast({
                    message: "请输入正确的手机号码",
                    duration: 1000,
                });
                return;
            }

            request
                .leaveMsg({
                    channelType: 1,
                    customerName: this.name,
                    customerPhone: this.phone,
                    customerEmail: this.customerEmail,
                    msgReason: 1,
                    msgContent: this.remark,
                    tenantId: this.$store.state.initData.tenantId,
                    userId: this.userInfo.userId,
                })
                .then((res) => {
                    console.log(res);

                    this.$store.dispatch("setConfigPc", [
                        { key: "showModal", value: false },
                        { key: "messageModal", value: false },
                    ]);

                    Toast({
                        message: "发送成功",
                        duration: 1000,
                    });
                });
        },
        // 更改评分
        chooseStar(star) {
            console.log(star)
            this.star = star;

            this.suggester = '';
        },
        // 发送评价
        sendEvaluate() {
          
            let param = {}
            if (this.$store.state.connectStatus === 'robot') {
                let arr = [];
                this.suggestion.forEach(sug => {
                    if (sug.value) {
                        arr.push(sug.name)
                    }
                })
                param.evaluateRobotTag = arr.join(',')
                param.evaluateRobotSolve = this.type
                param.evaluateRobotMode = 1;
                param.evaluateRobotContent = this.suggester; //评价客服内容，长度最大64

            } else {
                let arr = [];
                this.evaluateData.starList[this.star - 1].select.forEach(item => {
                    if (item.value) {
                        arr.push(item.name)
                    }
                })
                let starItem = this.evaluateData.starList[this.star - 1];
               
                if (this.evaluateData.starList[this.star - 1].evaluateMsgRequired && !this.suggester) {
                    // 必填评价
                    Toast({
                        message: this.$t('evaConInput'),
                        duration: 3000
                    });
                    return
                }
                if (this.evaluateData.starList[this.star - 1].levelTagRequired && arr.length === 0) {
                    // 必填评价
                    Toast({
                        message: this.$t('evaLabelSelect'),
                        duration: 3000
                    });
                    return
                }
                param.evaluateAdminSolve = this.type;
                param.evaluateAdminMode = 1;
                param.evaluateAdminContent = this.suggester; //评价客服内容，长度最大64
                param.evaluateAdminStar = this.star; //客服评价星级
                 param.evaluateAdminStarStr = starItem.levelGuideMsg; //客服评价星级
                param.evaluateAdminTag = arr.join(',');  //客服评价标签，多个逗号分隔，长度最大64
            }
            chatApi.sendEvaluate(param)
        },
        checkPhone(phone) {
            if (!phone) {
                return false;
            }
            return /^1(3|4|5|7|8|9)\d{9}$/.test(phone);
        },
    }
}
</script>

<style scoped>
.modal_content p {
    margin: 8px 2px;
}

.modal {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(1, 1, 1, .5);
    left: 0;
    top: 0;
    z-index: 9;
}

.modal_content {
    max-height: 420px;
    width: 100%;
    background: #ffffff;
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    height: 420px;
}

.modal_header {
    height: 50px;
    display: flex;
    justify-content: space-between;
    background-color: #f3f3f3;
}

.modal_title {
    font-size: 14px;
    color: #2a2a2c;
    margin: 10px 20px;
    line-height: 30px;
    cursor: pointer;
}

.modal_title span {
    margin-right: 10px;
    padding: 7px 5px;
}

.modal_title .active {
    color: #6c5df9;
}

.close {
    font-size: 18px;
    color: #999999;
    height: 24px;
    margin: 12px 20px;
    cursor: pointer;
}

.close::before {
    content: '\2716'
}

.modal_body {
    padding: 10px 30px 15px;
    flex: 1;
}

.modal_body>p {
    margin-top: 0;
    font-size: 14px;
}

.form_item>div {
    display: inline-block;
    width: 80px;
    vertical-align: middle;
    color: #666666;
}

.form_item {
    display: flex;
    align-items: center;
    margin: 15px auto;
    width: 80%;
}

.form_item .el-input,
.form_item .el-textarea {
    flex: 1;
    font-size: 14px;
    vertical-align: middle;
    color: #535151;
    outline: none;
}

textarea {
    flex: 1;
    resize: none;
    height: 42px;
    width: 440px;
    vertical-align: text-top;
    padding: 8px;
    border: 1px solid #e6e6e6;
    outline: none;
    color: #535151;
}

button {
    width: 180px;
    height: 32px;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    border: none;
}

div.row {
    width: 100%;
    max-width: 610px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.row .item {
    flex: 1;
    margin: 10px 5px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.row .item.active {
    color: white;
    border: none
}

.noData {
    height: 20px;
}

button {
    margin-top: 20px;
}

/*button:active {*/
/*  background-color: #6354f7;*/
/*}*/

.manual {
    min-height: 200px;
}

.manual .star {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-image: url("../../../static/image/star.png");
    background-size: 100% 100%;
    cursor: pointer;
}

.manual .star.active {
    background-image: url("../../../static/image/starActive.png");
}

.manual p {
    font-size: 14px;
    color: #00A1E2;
    margin: 15px;
}

.leave_msg_item {
    line-height: 14px;
    margin: 10px 5px;
    padding: 5px;
    background: #fafafa;
}

.leave_msg_item div {
    text-align: left;
    font-size: 16px;
    line-height: 18px;
    margin: 8px 0;
}

.leave_msg_item .label {
    width: 90px;
    display: inline-block;
    text-align: right;
    padding-left: 3px;
    color: #666;

}

.leave_msg_item .label+span {
    width: 60px;
}

.plf20{
    padding: 0 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/modal.vue